import { createSlice } from '@reduxjs/toolkit';
import { getAllDatabasesAction } from 'redux/actions/database';

const initialState = {
  databasesLoading: false,
  databases: [],
  loading: false,
};

// First import your thunk then add thunk lifecycle handlers
export const databaseSlice = createSlice({
  name: 'database',
  initialState,
  reducers: {},
  extraReducers: {
    [getAllDatabasesAction.pending]: (state) => {
      state.loading = true;
    },
    [getAllDatabasesAction.fulfilled]: (state, action) => {
      state.databases = action.payload;
      state.loading = false;
    },
    [getAllDatabasesAction.rejected]: (state) => {
      state.loading = false;
    },
  },
});

// export auto-generated action creators from the reducer
export const actions = databaseSlice.actions;
// export the reducer to be passed to configureStore
export default databaseSlice.reducer;
